import {Store} from "vuex";
import {ObjectRepository} from "@api/repositories/ObjectRepository";
import {DateTime} from "luxon";
import {QueryParametersInterface} from "@api/repositories/interfaces/QueryParametersInterface";
import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
import {QueryOperators} from "@api/enums/QueryOperators";

export class AgendaService {
    private readonly _agendaSchema: string;

    constructor(
        private readonly store: Store<any>,
        private readonly objectRepository: ObjectRepository
    ) {
        this._agendaSchema = process.env.VUE_APP_AGENDA_SCHEMA as string;
    }

    get schema() {
        return this._agendaSchema;
    }

    public async fetch(condition: any = {}) {
        try {
            let query: QueryParametersInterface = {
                take: -1,
                order: {
                    beginAt: 'asc'
                }
            };

            if (condition && Object.keys(condition).length) {
                query['where'] = condition;
            }

            return await this.objectRepository.query(this._agendaSchema, query);
        }
        catch (e) {
            this.store.dispatch('reportException', e, { root: true });
            return []
        }
    }

    public async fetchForDate({ eventId, dayStart }: { eventId: string; dayStart: DateTime }, groupFilter: any, filterOffline: boolean) {
       const condition = {
           eventId: eventId,
           '$and': [
               {
                   '$or': [
                       { beginAt: { '$gte': dayStart.toISO({ includeOffset: true }) } },
                       { onlineProvider: { '$eq': OnlineProvider.pastSessionRecord } }
                   ]
               },
               (filterOffline ? { onlineProvider: { '$exists': true } } : null),
           ],
           ...groupFilter
       }

       return await this.fetch(condition);
    }

    public async fetchByIds({eventId, ids}: { eventId: string; ids: string[] }, groupFilter: any) {
        if (ids && ids.length === 0) { return []; }

        const condition = {
            eventId: eventId,
            id: {
                [QueryOperators.in]: ids
            },
            ...groupFilter
        }

        return await this.fetch(condition);
    }

    public deleteById(id: string) {
        return this.objectRepository.delete(this.schema, [id]);
    }
}